export const createIndividualCreditCalcRepository = (appFetch) => {
    return {
        all(options) {
            return appFetch.get('/api/v1/calculators/credit', options);
        },
        credits(options) {
            return appFetch.get('/api/v1/calculators/credit/credit', options);
        },
        autocredits(options) {
            return appFetch.get('/api/v1/calculators/credit/autocredit', options);
        },
        mortgages(options) {
            return appFetch.get('/api/v1/calculators/credit/mortgage', options);
        },
    };
};
